export class Component {
    constructor(container) {
        this.container = container;
        // Код в конструкторе исполняется ДО всех объявлений в дочернем классе
    }
    // Включает или выключает переданный CSS-класс
    toggleClass(element, className, force) {
        element.classList.toggle(className, force);
    }
    // Устанавливает текстовое содержимое элемента
    setText(element, value) {
        if (element) {
            element.textContent = String(value);
        }
    }
    // Добавляет или снимает атрибут disabled
    setDisabled(element, state) {
        if (element) {
            if (state)
                element.setAttribute('disabled', 'disabled');
            else
                element.removeAttribute('disabled');
        }
    }
    // Скрывает элемент
    setHidden(element) {
        element.style.display = 'none';
    }
    // Показывает элемент
    setVisible(element) {
        element.style.removeProperty('display');
    }
    // Устанавливает изображение с алтернативным текстом
    setImage(element, src, alt) {
        if (element) {
            element.src = src;
            if (alt) {
                element.alt = alt;
            }
        }
    }
    // Возвращает корневой DOM-элемент (основной публичный метод, который обновляет компонент)
    render(data) {
        Object.assign(this, data !== null && data !== void 0 ? data : {});
        return this.container;
    }
}
